import { useEffect } from 'react';

// ----------------------------------------------------------------------

export function useShortcut(key, callback) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      const isMac = navigator.userAgent.toLowerCase().includes('mac');
      const isCmdOrCtrl = isMac ? event.metaKey : event.ctrlKey;
      if(isCmdOrCtrl && event.key.toLowerCase() === key) {
        event.preventDefault();
        callback();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [key, callback]);
}
